<template>
	<div class="hook-container">
		<div ref="hook"></div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { getUrl } from '@/helpers/api'
	import externalComponent from '@/external-component.js'
	
	export default {
		name: 'HookCustomRemote',
		props: {
			entidad: String,
			id: String,
			ficha: [String, Object],
			porlet: Object,
			componente: String,
			entidadRelacionada: String
		},
		data() {
			return {
				hookLoading: false
			}
		},
		async mounted () {

			this.$nextTick(async () => {
				
				this.hookLoading = true

                try {

					await externalComponent('https://10.0.4.117/backendalmacen/public/script.js')

					let component = window.components.ListaAgrupada

					if(component) {
						const ComponentClass = Vue.extend(component)
						
						const instance = new ComponentClass({
							propsData: {
								url: getUrl(),
								id: this.id,
								ficha: this.ficha,
								entidad: this.entidad,
								entidadRelacionada: this.porlet && this.porlet.entidadRelacionada,
								...this.$attrs
							}
						})

						instance.$on('updateFicha', (data) => this.$emit('updateFicha', data))
						instance.$on('reloadDataTable', (data) => this.$emit('reloadDataTable', data))
						instance.$on('loginsuccess', (data) => this.$emit('loginsuccess', data))

						instance.$mount()
						
						this.$refs.hook.appendChild(instance.$el)

						// this.$addRef('custom', instance) // Guardar referencia
						
					}

                } catch(e) {

					console.log(e)
				}
			})
                    
		}
	}
</script>

<style lang="scss">
.hook-container {
	height: 100%;
	.loading {
		position: absolute;
		background-color: white;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		z-index: 9999;
	}
	.hook {
		height: 100%;
		min-height: 70px!important;
	}
}

.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}	
</style>